"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorMapper = void 0;
const tslib_1 = require("tslib");
const models_1 = require("./models");
exports.errorMapper = (error, popupConfig, codesConfig, translate) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (!error) {
        return Promise.reject(error);
    }
    if (!error.response) {
        return error.code ? Promise.reject(Object.assign(Object.assign({}, error), { status: error.code })) : Promise.reject(error);
    }
    const { status, data } = error.response;
    const shortError = { status, data };
    return Promise.reject(mapErrors(shortError, popupConfig, codesConfig, translate));
});
const mapErrors = (error, popupConfig, codesConfig, translate) => {
    const { data, status } = error;
    const withPopupMessage = (codesConfig === null || codesConfig === void 0 ? void 0 : codesConfig.withPopupMessage) || models_1.defaultCodesWithPopupMessage;
    const withValidations = (codesConfig === null || codesConfig === void 0 ? void 0 : codesConfig.withValidations) || models_1.defaultCodesWithValidations;
    if (withValidations.includes(status)) {
        return {
            status,
            data,
            validation: mapValidationData(data, translate),
            validationCommon: mapValidationCommon(data, translate)
        };
    }
    if (popupConfig && withPopupMessage.includes(status)) {
        showPopupError({
            showError: popupConfig.showError,
            defaultError: data.message || data.error || popupConfig.defaultError
        }, translate);
    }
    return error;
};
const mapValidationCommon = (data, translate) => {
    const fieldsErrorsIsEmpty = data.errors && Object.keys(data.errors).length === 0;
    return !data.errors || fieldsErrorsIsEmpty ? translateErrors(data, translate) : undefined;
};
const mapValidationData = (data, translate) => {
    const fieldsErrorsIsEmpty = data.errors && Object.keys(data.errors).length === 0;
    if (!data.errors || fieldsErrorsIsEmpty) {
        return undefined;
    }
    const result = {};
    for (const [key, value] of Object.entries(data.errors)) {
        const keyWithoutFirstDot = key.replace(/^\./, '');
        result[keyWithoutFirstDot] = value.map(item => translateErrors(item, translate));
    }
    if (Object.keys(result).length === 0) {
        return { [models_1.DEFAULT_VALIDATION_FIELD]: translateErrors(data, translate) };
    }
    return result;
};
const translateErrors = (data, t) => {
    const { code, message, params } = data;
    return t ? t([code, message, params]) : message;
};
const showPopupError = (popupConfig, translate) => {
    const { showError, defaultError } = popupConfig;
    return translate ? showError(translate(defaultError)) : showError(defaultError);
};
//# sourceMappingURL=mappers.js.map